import { Section } from "@/components/common";
import { useLoad, act } from "@/lib/hooks";
import { api } from "@/lib/api";

const OPTIONS = [["quote", "Create draft quote", "Default. Winning an opportunity creates a draft quote, or offers to link one of the customer's existing quotes."],
  ["job", "Create job directly", "For POS / walk-in shops: skips the quote and creates a draft job."]];

export function CrmSettings({ can }) {
  const [s, reload] = useLoad("/crm/settings");
  if (!s) return null;
  const cur = s.on_won || "quote";
  const save = async (v) => { if (await act(() => api.put("/crm/settings/on-won", { on_won: v }), "CRM setting saved")) reload(); };
  return (
    <Section title="CRM: on Won" testId="crm-settings-section">
      <div className="grid gap-3 p-5 sm:grid-cols-2" role="radiogroup">
        {OPTIONS.map(([v, label, hint]) => (
          <button key={v} type="button" role="radio" aria-checked={cur === v} disabled={!can} data-testid={`crm-on-won-${v}`} onClick={() => save(v)}
            className={`rounded-lg border p-4 text-left transition-colors ${cur === v ? "border-[#45BFB4] bg-[#E6F8F6]" : "border-slate-200 hover:border-slate-300"}`}>
            <div className="text-sm font-semibold text-slate-900">{label}</div><div className="mt-1 text-xs text-slate-500">{hint}</div>
          </button>
        ))}
      </div>
    </Section>
  );
}
